module.exports = __webpack_public_path__ + "img/HITACHI-background.02baf8ff.png";